// extracted by mini-css-extract-plugin
export default {"container-header":"ContainerHeader_container-header__djCfp"};